module.exports = {"371423001":"渤海路街道","371423100":"庆云镇","371423101":"常家镇","371423102":"尚堂镇","371423103":"崔口镇","371423104":"东辛店镇","371423200":"严务乡","371423202":"中丁乡","371423203":"徐园子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371423.json
// module id = 1475
// module chunks = 0